import { useState, useEffect, useRef } from 'react';
import styles from './index.module.scss';
import Matter from 'matter-js';
import decomp from 'poly-decomp';
window.decomp = decomp;

export const Sparkles = () => {
  const boxRef = useRef(null);
  const canvasRef = useRef(null);

  const [contraints, setContraints] = useState();
  const [scene, setScene] = useState();

  const handleResize = () => {
    setContraints(boxRef.current.getBoundingClientRect());
  };

  useEffect(() => {
    if (contraints) {
      let { width, height } = contraints;

      // dynamically update canvas and bounds
      scene.bounds.max.x = width;
      scene.bounds.max.y = height;
      scene.options.width = width;
      scene.options.height = height;
      scene.canvas.width = width;
      scene.canvas.height = height;
    }
  }, [scene, contraints]);

  useEffect(() => {
    let Engine = Matter.Engine;
    let Render = Matter.Render;
    let World = Matter.World;
    let Bodies = Matter.Bodies;
    let Body = Matter.Body;

    let engine = Engine.create({});
    let render = Render.create({
      element: boxRef.current,
      engine: engine,
      canvas: canvasRef.current,
      options: {
        background: 'transparent',
        wireframes: false,
      },
    });

    const leftSparkles = [];
    const rightSparkles = [];
    const topSparkles = [];

    // left & right sparkles
    for (let i = 0; i < 30; i++) {
      let leftRandomX = Math.random() * -300 - 50;
      let rightRandomX = Math.random() * 300 + 50 + window.innerWidth;
      let randomY = Math.random() * -400;
      let randomSizeA = Math.floor(Math.random()) + 6;
      let randomSizeB = Math.floor(Math.random()) + 12;
      let randomCount = Math.random() * 10;
      let color = ['#abd6fe', '#66fecb', '#fe9ee3', '#fef001'];
      let colorPos = Math.floor(Math.random() * 4);

      let options = {
        frictionAir: 0.035,
        render: {
          fillStyle: color[colorPos],
        },
      };

      if (randomCount > 5) {
        leftSparkles.push(
          Bodies.circle(leftRandomX, randomY, randomSizeA, options),
        );
        rightSparkles.push(
          Bodies.circle(rightRandomX, randomY, randomSizeA, options),
        );
      } else {
        leftSparkles.push(
          Bodies.rectangle(
            leftRandomX,
            randomY,
            randomSizeA,
            randomSizeB,
            options,
          ),
        );
        rightSparkles.push(
          Bodies.rectangle(
            rightRandomX,
            randomY,
            randomSizeA,
            randomSizeB,
            options,
          ),
        );
      }
    }

    // top sparkles
    for (let i = 0; i < 15; i++) {
      let randomX = Math.random() * window.innerWidth;
      let randomY = Math.random() * -400 - 150;
      let randomSizeA = Math.floor(Math.random()) + 4;
      let randomSizeB = Math.floor(Math.random()) + 8;
      let randomCount = Math.random() * 10;
      let color = ['#abd6fe', '#66fecb', '#fe9ee3', '#fef001'];
      let colorPos = Math.floor(Math.random() * 4);

      let options = {
        frictionAir: 0.05,
        isStatic: true,
        render: {
          fillStyle: color[colorPos],
        },
      };

      if (randomCount > 5) {
        topSparkles.push(Bodies.circle(randomX, randomY, randomSizeA, options));
      } else {
        topSparkles.push(
          Bodies.rectangle(randomX, randomY, randomSizeA, randomSizeB, options),
        );
      }
    }

    World.add(engine.world, [
      ...leftSparkles,
      ...rightSparkles,
      ...topSparkles,
    ]);

    Engine.run(engine);
    Render.run(render);

    topSparkles.map((sparkle) => {
      Body.setVelocity(sparkle, { x: 0, y: -10 });
      Body.setAngularVelocity(sparkle, Math.PI / 5);
      return '';
    });

    const runMatterBlow = () => {
      leftSparkles.map((sparkle) => {
        Body.setVelocity(sparkle, { x: 10, y: -(Math.random() * 10 + 9) });
        Body.setAngularVelocity(sparkle, Math.PI / 10);
        return '';
      });

      rightSparkles.map((sparkle) => {
        Body.setVelocity(sparkle, { x: -10, y: -(Math.random() * 10 + 9) });
        Body.setAngularVelocity(sparkle, Math.PI / 10);
        return '';
      });
    };

    const runMatterDrop = () => {
      topSparkles.map((sparkle) => {
        Body.setStatic(sparkle, false);
        return '';
      });
    };

    setTimeout(runMatterBlow, 700);
    setTimeout(runMatterDrop, 300);

    setContraints(boxRef.current.getBoundingClientRect());
    setScene(render);
    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(runMatterBlow);
      clearTimeout(runMatterDrop);
    };
  }, []);

  return (
    <div ref={boxRef} className={styles.canvas}>
      <canvas ref={canvasRef} />
    </div>
  );
};
